import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { nameOf } from '../../shared/functions/nameOf';
import { EmailDto } from '../../proof-of-audit/models/EmailDto';
import { TextAreaComponent } from '../text-area/text-area.component';

@Component({
  selector: 'email-body',
  templateUrl: './email-body.component.html',
  styleUrls: ['./email-body.component.scss'],
})
export class EmailBodyComponent implements OnInit {
  @Input() subjectTitle = 'Subject';
  @Input() bodyTitle = 'Email';
  @Input() subject = '';
  @Input() body = '';

  @Output() formChange = new EventEmitter<FormGroup>();

  @ViewChild(TextAreaComponent) subjectTextComponent!: TextAreaComponent;

  emailForm: FormGroup = new FormGroup({});
  maxEmailSubjectChars: number = 200;
  maxEmailChars: number = 2500;

  constructor() {}

  ngOnInit() {
    this.createForm();
    this.initializeForm();
  }

  private createForm() {
    this.emailForm = new FormGroup({
      subject: new FormControl('', [
        Validators.required,
        Validators.maxLength(this.maxEmailSubjectChars),
      ]),
      body: new FormControl('', [Validators.required]),
    });
  }

  private initializeForm() {
    this.emailForm
      .get(nameOf<EmailDto>('subject'))
      ?.setValue(this.getRequestContent(this.subject));
    this.emailForm
      .get(nameOf<EmailDto>('body'))
      ?.setValue(this.getRequestContent(this.body));

    this.emailForm.valueChanges.subscribe(() => {
      this.formChange.emit(this.emailForm);
    });
  }

  private getRequestContent(content: string) {
    return decodeURIComponent(content)
      .replace(/&nbsp;/g, ' ') // Replace non-breaking spaces
      .replace(/&quot;/g, '"') // Replace quotes
      .replace(/<\/?p>/g, ''); // Remove <p> and </p> tags
  }

  reset(): void {
    this.emailForm.reset();

    if (this.subjectTextComponent) {
      this.subjectTextComponent.clear();
    }

    this.initializeForm();
    this.emailForm.markAsPristine();
  }
}
